import React from 'react';
import './Style.css';
import { current } from '@reduxjs/toolkit';

const currentYear = new Date().getFullYear();
const Footer: React.FC = () => {
  return (
    <footer>
      <p>Copyright &copy; {currentYear} - All rights reserved. Acu Trans Solution LLC.</p>
    </footer>
  );
};

export default Footer;
